// Client
export { ApiClient } from "./client.js";
export { HTTP_CLIENT_DEBUG_NAMESPACE } from "./logging.js";
export type {
  ApiClientOptions,
  ApiClientValidationErrorLocation,
  ApiClientValidationErrorContext,
  ApiClientValidationErrorHandler,
} from "./client.js";

// Errors
export {
  ApiClientError,
  UnexpectedApiClientError,
  ValidationError,
  TimeoutError,
} from "./errors.js";

// Types
export type {
  ApiRequestSchema,
  ApiResponseSchema,
  // Executor interface
  HttpExecutor,
  ExecuteRequest,
  ExecuteResponse,
  // Logging
  LogLevel,
  LogMeta,
  LogHandler,
  Logger,
  ApiClientLoggingOptions,
  // Request types
  ExtractPathParams,
  ExtractRequestParams,
  ExtractRequestQuery,
  ExtractRequestBody,
  ParamsRequired,
  BodyRequired,
  EndpointsWithMethod,
  RequestOptions,
  RetryContext,
  // Response types
  ExtractStatusCodes,
  ExtractSuccessCodes,
  ExtractErrorCodes,
  ExtractResponseSchema,
  ExtractSuccessBody,
  SuccessResponse,
  ErrorResponse,
  UnexpectedErrorResponse,
  ApiResponse,
} from "./types.js";
